import { render, staticRenderFns } from "./ItemMoudle.vue?vue&type=template&id=4273597a&scoped=true&"
import script from "./ItemMoudle.vue?vue&type=script&lang=js&"
export * from "./ItemMoudle.vue?vue&type=script&lang=js&"
import style0 from "./ItemMoudle.vue?vue&type=style&index=0&id=4273597a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273597a",
  null
  
)

export default component.exports